// Tells the Cognito custom message Lambda (lambda/cognito_custom_message) which site to
// point the "Verify my email" link at. The Lambda only accepts origins on its allowlist.
export const EMAIL_LINK_OPTIONS = { clientMetadata: { origin: window.location.origin } };
